import { useState } from 'react'
import { userProfileImages } from '../../services/images.service'

export function UserDetails({ user }) {
  const [openSection, setOpenSection] = useState(null)

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section)
  }

  const favoriteAnime = user.favoriteAnime || 'לא הוזן מידע'
  const favoriteCharacter = user.favoriteCharacter || 'לא הוזן מידע'
  const favoriteQuote = user.favoriteQuote || 'לא הוזן מידע'
  const favoriteCategories = user.favoriteCategories?.length
    ? user.favoriteCategories
    : ['לא הוזן מידע']

  return (
    <div className="w-[95%] mx-auto flex flex-col gap-2 mt-4">
      {/* קצת עליי */}
      <div className="bg-accent border-r-2 border-red-600">
        <div className="flex justify-between items-center p-4">
          <p className="text-muted">קצת עליי</p>
          <button onClick={() => toggleSection('bio')}>
            <img
              src={
                openSection === 'bio'
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Bio"
            />
          </button>
        </div>
        {openSection === 'bio' && (
          <div className="p-4 text-softText">{user.bio || 'לא הוזן מידע'}</div>
        )}
      </div>

      {/* קטגוריות מועדפות */}
      <div className="bg-accent border-r-2 border-red-600">
        <div className="flex justify-between items-center p-4">
          <p className="text-muted">קטגוריות מועדפות</p>
          <button onClick={() => toggleSection('categories')}>
            <img
              src={
                openSection === 'categories'
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Categories"
            />
          </button>
        </div>
        {openSection === 'categories' && (
          <div className="p-4 flex flex-wrap gap-4">
            {favoriteCategories.map((category, index) => (
              <div
                key={index}
                className="p-4 border-2 border-red-600 rounded shadow text-center"
              >
                {category}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* אנימה מועדפת */}
      <div className="bg-accent border-r-2 border-red-600">
        <div className="flex justify-between items-center p-4">
          <p className="text-muted">אנימה מועדפת</p>
          <button onClick={() => toggleSection('anime')}>
            <img
              src={
                openSection === 'anime'
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Anime"
            />
          </button>
        </div>
        {openSection === 'anime' && (
          <div className="p-4 text-softText">{favoriteAnime}</div>
        )}
      </div>

      {/* דמות מועדפת */}
      <div className="bg-accent border-r-2 border-red-600">
        <div className="flex justify-between items-center p-4">
          <p className="text-muted">דמות מועדפת</p>
          <button onClick={() => toggleSection('character')}>
            <img
              src={
                openSection === 'character'
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Character"
            />
          </button>
        </div>
        {openSection === 'character' && (
          <div className="p-4 text-softText">{favoriteCharacter}</div>
        )}
      </div>

      {/* ציטוט מועדף */}
      <div className="bg-accent border-r-2 border-red-600">
        <div className="flex justify-between items-center p-4">
          <p className="text-muted">ציטוט מועדף</p>
          <button onClick={() => toggleSection('quote')}>
            <img
              src={
                openSection === 'quote'
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Quote"
            />
          </button>
        </div>
        {openSection === 'quote' && (
          <div className="p-4 text-softText">{favoriteQuote}</div>
        )}
      </div>
    </div>
  )
}
